import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SonatypeLifecycleConfigListing from './SonatypeLifecycleConfigListing'
import SonatypeLifecycleCredentialsForm from './SonatypeLifecycleCredentialsForm'

export default function SonatypeLifecyclePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SonatypeLifecycleCredentialsForm}
            PullConfigListingView={SonatypeLifecycleConfigListing}
        />
    )
}